import React from 'react';
import { TableHead, TableRow, TableCell } from '@mui/material';
import { TABLE_COLUMNS } from './constants';

const TableHeader = () => (
  <TableHead>
    <TableRow>
      <TableCell>{TABLE_COLUMNS.NAME}</TableCell>
      <TableCell>{TABLE_COLUMNS.SIZE}</TableCell>
      <TableCell>{TABLE_COLUMNS.VALIDATION_STATUS}</TableCell>
      <TableCell>{TABLE_COLUMNS.STATUS}</TableCell>
      <TableCell align="center">{TABLE_COLUMNS.ACTIONS}</TableCell>
      <TableCell align="center">{TABLE_COLUMNS.ICONS}</TableCell>
    </TableRow>
  </TableHead>
);

export default TableHeader;
